@if(useCollections()) {
<app-aq-collections></app-aq-collections>
} @else {
<app-insights-airquality-config></app-insights-airquality-config>
}
